import {createGenericApi} from "./createGenericApi";
import {API_SUBSCRIBER} from "Models/Subscriber/SubscriberEndpoints";
import {API_AUDITS} from "../Models/Audit/AuditEndpoints";

export const subscriberApi = createGenericApi({
    reducerPath: "subscriberApi",
    baseUrl: API_SUBSCRIBER.subscribers,
    tagTypes: ["Subscriber"],
});

export const {
    useFetchItemsQuery: useFetchSubscribersQuery,
    useAddItemMutation: useAddSubscriberMutation,
    useUpdateItemMutation: useUpdateSubscriberMutation,
    useDeleteItemMutation: useDeleteSubscriberMutation,
} = subscriberApi;


export const subscriberAuditTypeItemsApi = createGenericApi({
    reducerPath: "subscriberAuditTypeItemsApi",
    baseUrl: API_AUDITS.auditsTypesItems,
    tagTypes: ["subscriberAuditTypeItem"],
    updateAction: "override_by_subscriber/",
});

export const {
    useFetchItemsQuery: useFetchSubscribersAuditTypeItemQuery,
    useAddItemMutation: useAddSubscribersAuditTypeItemMutation,
    useUpdateItemMutation: useUpdateSubscribersAuditTypeItemMutation,
    useDeleteItemMutation: useDeleteSubscribersAuditTypeItemMutation,
} = subscriberAuditTypeItemsApi;

export const subscriberAuditTypesApi = createGenericApi({
    reducerPath: "subscriberAuditTypesApi",
    baseUrl: API_AUDITS.auditsTypes,
    tagTypes: ["subscriberAuditType"],
    updateAction: "override_by_subscriber/",
});

export const {
    useFetchItemsQuery: useFetchSubscribersAuditTypeQuery,
    useAddItemMutation: useAddSubscribersAuditTypeMutation,
    useUpdateItemMutation: useUpdateSubscribersAuditTypeMutation,
    useDeleteItemMutation: useDeleteSubscribersAuditTypeMutation,
} = subscriberAuditTypesApi;

export const subscriberInspectionsQuestionsApi = createGenericApi({
    reducerPath: "subscriberInspectionsQuestionsApi",
    baseUrl: API_AUDITS.questions,
    tagTypes: ["subscriberInspectionsQuestions"],
    updateAction: "override_by_subscriber/",
});

export const {
    useFetchItemsQuery: useFetchSubscribersInspectionsQuestionQuery,
    useAddItemMutation: useAddSubscribersInspectionsQuestionMutation,
    useUpdateItemMutation: useUpdateSubscribersInspectionsQuestionMutation,
    useDeleteItemMutation: useDeleteSubscribersInspectionsQuestionMutation,
} = subscriberInspectionsQuestionsApi;
